/* setState seguro - só aplica se o componente ainda estiver montado */
export function safeSetState(newState, callback) {
    if (this._isMounted) {
        this.setState(newState, callback);
    }
};